<div class="row">
  <div class="col-md-12">
    <div class="form-group">
      <label class="control-label">Name</label>
      <input type="text" #name class="form-control" name="Name" [(ngModel)]="model.Name" />
      <app-tooltip [form]="'system.entityGroup'" [uid]="'Name'"></app-tooltip>
    </div>
  </div>
</div>
